import React from 'react';
import $ from "jquery";
import * as pagesReducers from "../../reducers/pages";

import {IMGIX_PATH} from "../../constants";

class HeaderBar extends React.Component {
    constructor(props) {
        super(props);
        this.state= {
            loggedOut : false,
            userDet : JSON.parse(window.localStorage.userDet)
        }
        this.logout = this.logout.bind(this);

    }

    componentDidMount() {

        //mobile query
        const mq = window.matchMedia( "(max-width: 767px)" );
        if (mq.matches) {

            $('.content-area').removeClass('inner-skew');
            //mobile
            $('.menu-toggle-button').click(function() {
                $(this).closest('.wrapper').find('.side-content-area').toggleClass('active');
            });

        }
        else{
            $('.menu-toggle-button').click(function() {
                $(this).closest('.wrapper').find('.content-area').toggleClass('inner-skew');
            });
        }
        if($('.user-image').length > 0) {
            $('.user-image').click(function() {
                $(this).closest('.user-block').find('.user-toggle').slideToggle('active');
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {


    }

    logout() {
        window.localStorage.removeItem('userDet');
        window.location = 'https://agency.vignets.com/vignetsv2/#/';
    }

    render() {


        let profileImgSrc = IMGIX_PATH+'assets/slider/'+this.state.userDet.user_id+'.jpg?fit=crop&h=150&w=150&auto=enhance&dpr=3%203x';
        return (

            <header className="header-block">
                <div className="header-block-wrapper">
                    <div className="brand-logo">
                        <img src={require('../../assets/images/vignets_logo.png')} alt="Vignet" />
                    </div>
                    <div className="center-block">
                        <div className="toggle-block">
                            <button className="icon-lib-list menu-toggle-button"></button>
                        </div>
                        <div className="user-info-block">
                            {/*<ul className="info-list">
                                <li className="ind-info">
                                    <a href="javascript:void(0);" className="info-click icon-lib-list info">&nbsp;</a>
                                </li>
                                <li className="ind-info">
                                    <a href="javascript:void(0);"
                                       className="info-click icon-lib-list message">&nbsp;</a>
                                </li>
                                <li className="ind-info new-alert">
                                    <a href="javascript:void(0);"
                                       className="info-click icon-lib-list notification">&nbsp;</a>
                                </li>
                            </ul>*/
                            }
                            <div className="user-block">
                                <a className="user-image icon-lib-af drop-ico" href="javascript:void(0);">
                                    <img src={profileImgSrc} alt="User" />
                                </a>
                                <div className="user-toggle">
                                    <ul>
                                        <li>
                                            <a href="javascript:void(0);" className="user-toggle-click">Profile</a>
                                        </li>
                                        <li>
                                            <a href="javascript:;" className="user-toggle-click" onClick={this.logout}>Logout</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </header>

        );
    }
}
function mapStateToProps(state) {
    return {
        loggedinData  :pagesReducers.getPageSettings(state)
    };

}
export default  HeaderBar;



// WEBPACK FOOTER //
// ./src/components/common/HeaderBar.js